<!-- 顶部返回按钮-吴影茹 -->
<template>
  <div class="row_center back_btn" @click="back">
    <arrow-left-outlined class="back_btn_icon" />
    <div class="back_btn_text">返回</div>
  </div>
</template>
            
<script setup lang="ts">
import { onMounted, ref, getCurrentInstance, nextTick, watch } from 'vue'
import { ArrowLeftOutlined } from '@ant-design/icons-vue'
import { useRouter } from 'vue-router'
const router = useRouter()

onMounted(() => {})

const back = () => {
  router.back()
}
</script>
            
<style lang="scss" scoped>
.back_btn {
  cursor: pointer;
  margin-bottom: 20px;
}
.back_btn:hover {
  .back_btn_icon {
    color: #1677ff;
  }
  .back_btn_text {
    color: #1677ff;
  }
}
.back_btn_icon {
  font-size: 15px;
  color: gray;
}
.back_btn_text {
  font-size: 15px;
  color: gray;
  margin-left: 10px;
}
</style>